<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="forms"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="data.name"
        class="table-cursor-hand"
        @click:row="clickRow"
        :loading="loading"
        :loading-text="$t('table.loading')"
      >
        <template v-slot:item.created_at="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ timeDifference(new Date(item.created_at)) }}</span>
            </template>
            <span
            >{{ new Date(item.created_at).toISOString().substr(0, 10) }}
          {{ new Date(item.created_at).toTimeString().substr(0, 8) }}</span
            >
          </v-tooltip>
        </template>
        <template v-slot:item.form_name="{ item }">
          <span>{{$t(item.object_type + '.title')}} - {{ getFormName(item.form_name) }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import investigatorTablesMethods from "../../mixins/investigatorTablesMethods";
export default {
  mixins: [investigatorTablesMethods],
  data() {
    return {
      search: "",
      loading: true,
      forms: []
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("name"), value: "title"},
        {
          text: this.$t("formName"),
          value: "form_name"},
        { text: this.$t("create"), value: "created_at"},
        { text: this.$t("owner"), value: "owner.username" },
        {
          text: this.$t("supervisor"),
          value: "supervisor.username",
        },
      ];
    }
  },
  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path =
        this.$store.state.endpoint + "/direction/moderatedOperations/authorize";
      axios
        .get(path)
        .then(response => {
          this.forms = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },

    clickRow(item){
      this.$router.push({
        path: `/direction/forms/authorize/${item.object_type}/${item.form_name}/${item.id}`
      })
    }
  }
};
</script>
